export enum ResponseCode {
  Ok = 200,
  NotModified = 304,
  NotFound = 404,
  BadRequest = 502,
  Errored = 500,
  LogicError = 5,
}
